import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import CloseIcon from '@svg/close.svg';
import { addNewProduct } from '@urls';
import { useIsClient } from '@utils/common';
import { ShafaLogo } from '@ui/ShafaLogo';
import { Button } from '@ui/Button';
import { Link } from '@ui/Link';
import { Skeleton } from '@ui/Skeleton';
import { HeaderSearchContainer, RootCatalog } from '@containers/HeaderSearch';
import { LanguageToggle } from '@components/LanguageToggle';
import { HeaderAuthLinks } from '@components/HeaderAuthLinks';
import { FastLink, HeaderFastLinks } from '@components/HeaderFastLinks';
import { HeaderUserMenu, UserMenuLink } from '@components/HeaderUserMenu';

import s from './HeaderDesktop.sss';

interface User {
  id: number,
  username: string,
  avatar?: string | null,
  unreadMessagesCount: number,
  hasUnreadNotifications?: boolean | null,
  isSeller: boolean,
}

interface Props {
  className?: string,
  rootCatalogs?: RootCatalog[],
  user?: User | null,
  fastLinks: FastLink[],
  userMenuLinks: UserMenuLink[],
  isUserLoading?: boolean,
}

export const HeaderDesktop: React.FC<Props> = ({
  className,
  rootCatalogs,
  user,
  fastLinks,
  userMenuLinks,
  isUserLoading,
}) => {
  const history = useHistory();
  const location = useLocation();
  const isClient = useIsClient();

  const isCanary = isClient && window.IS_CANARY;

  const addNewProductHref = history.createHref({ pathname: addNewProduct });

  return (
    <div className={classNames(s.root, className)}>
      <section className={s.logoSection}>
        <Link
          className={s.logoLink}
          href="/"
        >
          <ShafaLogo
            className={s.logo}
            width="130"
            height="36"
          />
        </Link>

        {isCanary && (
          <Link
            className={s.canary}
            href="/canary-off"
            theme="clean"
            title="CANARY"
          >
            <CloseIcon
              className={s.canaryClose}
              width="24"
              height="24"
            />
          </Link>
        )}
      </section>

      <section className={s.searchSection}>
        <div className={s.search}>
          <HeaderSearchContainer rootCatalogs={rootCatalogs} />
        </div>

        <Button
          className={s.addButton}
          theme="secondary"
          onClick={() => window.location.href = addNewProductHref}
        >
          {t`Додати товар`}
        </Button>
      </section>

      <LanguageToggle
        className={s.languageToggle}
        pathname={location.pathname}
      />

      <section className={s.userSection}>
        {!!user ? (
          <>
            <HeaderFastLinks fastLinks={fastLinks} />
            <HeaderUserMenu
              user={user}
              links={userMenuLinks}
            />
          </>
        ) : (
          <>
            {isUserLoading ? (
              <Skeleton
                type='circle'
                width='40px'
                height='40px'
              />
            ) : (
              <HeaderAuthLinks />
            )}
          </>
        )}
      </section>
    </div>
  );
};
